<div class="wrapper {{className}}" [ngStyle]="{'margin-left': !utilService.hasHeader || utilService.isMobile ? 0 : utilService.sidenavWidth + 'px'}"
     [ngClass]="{'has-header': utilService.hasHeader || utilService.isMobile}">
  <mat-icon class="svg-icon" [svgIcon]="className || className[0]"></mat-icon>
  <div class="message-text">
    <ng-template #snackMessageTemplate let-item="item">{{item | translate}}</ng-template>
    <app-show-more [maxItems]="3" [inputTemplate]="snackMessageTemplate" [inputItems]="messages" [useList]="true"></app-show-more>
    <a *ngIf="action" class="link" (click)="dismissWithAction()">
      <span>{{ actionName | translate }}</span>
      <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
    </a>
  </div>
  <!--<mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>-->
  <button mat-button (click)="dismiss()">
    <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
  </button>
</div>
